import { Command } from 'commands/Commands';

export class RemoveAwardFromBusiness extends Command {
  type: string = 'Award.RemoveFromBusiness';
  constructor(payload: string, id: string = payload) {
    super(payload, id);
  }
  priority: number = 100;
}
